<template>
  <div>
    <b-modal size="lg" no-close-on-backdrop hide-header-close v-model="state" title="Relatório Vendas Varejo">

      <b-row class="mt-3">
        <b-col>
          <label for="">Mês</label>
          <b-form-select :options="optionsMes" v-model="mes"></b-form-select>
        </b-col>
        <b-col>
          <label for="">Ano</label>
          <b-form-select :options="optionsAno" v-model="ano"></b-form-select>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <label for="">Tipo</label>
          <b-form-select :options="optionsTipo" v-model="tipo"></b-form-select>
        </b-col>
      </b-row>
      <template #modal-footer>

        <b-button :disabled="loading" size="sm" variant="success" @click="exportar()">
          <i v-if="!loading" class="fas fa-file-excel"></i>
          <b-spinner v-else small></b-spinner>
          Exportar
        </b-button>
        <b-button :disabled="loading" size="sm" variant="danger" @click="statusModal">Fechar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "relatorio-varejo",
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  components: {
    // downloadexcel,
  },

  data() {
    return {
      loading: false,
      loadAtt: false,
      mes: moment().format('MM'),
      ano: moment().format('YYYY'),
      tipo: 'TODOS',
      optionsTipo: [
        { value: 'TODOS', text: 'Todos' },
        { value: 'ATENDIDO', text: 'Atendidos' },
        { value: 'FALTA', text: 'Faltas' },
        { value: 'BRINDE', text: 'Brindes' },
      ],
      status: 'aberto',
      optionsMes: [
        { value: '01', text: 'Janeiro' },
        { value: '02', text: 'Fevereiro' },
        { value: '03', text: 'Março' },
        { value: '04', text: 'Abril' },
        { value: '05', text: 'Maio' },
        { value: '06', text: 'Junho' },
        { value: '07', text: 'Julho' },
        { value: '08', text: 'Agosto' },
        { value: '09', text: 'Setembro' },
        { value: '10', text: 'Outubro' },
        { value: '11', text: 'Novembro' },
        { value: '12', text: 'Dezembro' },
      ],
      optionsAno: ['2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030']
    }
  },
  watch: {
    tipoUsuario() {
      this.porcentagem = null
      this.representante = null
    }
  },
  methods: {    
    statusModal() {
      this.$emit('update-modal', !this.state);
    },

    exportar(tipo) {
      const vm = this;
      this.loading = true
      const codigo = this.mes + '-' + this.ano + '-' + this.tipo;
      window.open('/adm/relatorio/varejo-item/' + codigo, "_blank");     
      this.loading = false;
    },

    getRepresentantes() {
      const vm = this;
      let arrG = [{
        text: 'Selecione o gerente',
        value: null
      }]
      let arr = [{
        text: 'Selecione o representante',
        value: null
      }];
      axios
        .get("/adm/users/representantes")
        .then((response) => {
          response.data.forEach((el) => {
            if (el.representante) {
              arr.push({
                text: el.codigo + ' - ' + el.nome,
                value: el.codigo
              })
            }
            if (el.gerente) {
              arrG.push({
                text: el.codigo + ' - ' + el.nome,
                value: el.codigo
              })
            }
          })
          vm.representantes = arr;
          vm.gerentes = arrG
        }).catch((erro) => {
          console.log(erro);
        })
    },
  },
  mounted() {
    this.getRepresentantes();
  },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/relatorios/componentes/relatorio-item-varejo.vue